import { readError } from './api';
import { clearPrivateDeviceData } from './offlineCloset';

export async function downloadPrivateExport(): Promise<void> {
  const response = await fetch('/api/privacy/export', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(await readError(response));
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `her-closet-${new Date().toISOString().slice(0, 10)}.json`;
  link.click();
  URL.revokeObjectURL(url);
}

export async function deletePrivateClosetData(): Promise<void> {
  const response = await fetch('/api/privacy/data', {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ confirmation: 'DELETE' }),
  });
  if (!response.ok) throw new Error(await readError(response));
  await clearPrivateDeviceData();
}
